















































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import "../BudgetView.scss";
import {Ax} from "@/utils";
import JournalTable from "@/modules/budget/components/Journal.vue";
import store from "@/services/store";

interface FileBodyItem {
    abp: string;
    name: string;
    opening_balance: string;
    debit: string;
    credit: string;
    saldo_period: string;
    closing_balance: string;
    abp_gu: string;
    region_code: string;
    budget_type_code: string;
    funding_source_code: string;
    unit: string;
    period: string; // или `Date`, если вы будете парсить в дату
    prev_period: string; // это единственное поле с числовым значением
}

@Component({
    components: {JournalTable}
})
export default class PdfLoader534A extends Vue {
    @Prop({type: Object, required: true}) propData!: null;
    @Prop({type: [], required: true}) fileBody!: [FileBodyItem];
    // @Prop({type: String}) fileName!: string;
    @Prop({type: File}) file!: File;
    @Prop({type: []}) fileArray!: [];

    get fileName(): string {
        return this.file ? this.file.name : '';
    }

    light: string = "light";
    fields = [
        {key: "region_code", label: "Регион", sortable: false},
        {key: "abp", label: "АБП/ГУ", sortable: false},
        {key: "name", label: "Наименование", sortable: false},
        {key: "prev_period", label: "Исходящий остаток предыдущего дня", sortable: false},
        {key: "opening_balance", label: "Входящий остаток", sortable: false},
        {key: "debit", label: "Дебет", sortable: false},
        {key: "credit", label: "Кредит", sortable: false},
        {key: "saldo_period", label: "Сальдо за период", sortable: false},
        {key: "closing_balance", label: "Исходящий остаток", sortable: false}
    ];

    get_tr_class(item: any) {
        if (!item) return '';
        const prevPeriod = parseFloat(item.prev_period);
        const openingBalance = parseFloat(item.opening_balance);
        const turnoverDebit = parseFloat(item.debit);
        const turnoverCredit = parseFloat(item.credit);
        const closingBalance = parseFloat(item.closing_balance);

        let isPrevMismatch = prevPeriod !== openingBalance;
        if (isPrevMismatch) {
            isPrevMismatch = !item.prev_period.toString().toLowerCase().startsWith("нет");
        }
        const expectedClosing = openingBalance + turnoverDebit - turnoverCredit;
        const isClosingMismatch = closingBalance !== expectedClosing;

        return isPrevMismatch || isClosingMismatch ? 'table-danger' : '';
    }

    error_text_1 = ""
    error_text_2 = ""

    get is_legal_unit(): boolean {
        const data = this.propData;
        if (!data) return true;
        if (data["unit"] == "") return true;
        if (data["unit"]) {
            const unit = (data["unit"] as string).toLowerCase().trim();
            const validPrefixes = ["тенге", "теңге"];
            if (validPrefixes.some(prefix => unit.startsWith(prefix))) return true;

        }
        return false
    }

    get error_rows() {
        let result = 0;
        const floatEquals = (a: number, b: number, tolerance = 0.0001) => Math.abs(a - b) < tolerance;
        if (Array.isArray(this.fileBody)) {
            for (const item of this.fileBody) {
                const prevPeriod = parseFloat(item.prev_period);
                const openingBalance = parseFloat(item.opening_balance);
                const turnoverDebit = parseFloat(item.debit);
                const turnoverCredit = parseFloat(item.credit);
                const closingBalance = parseFloat(item.closing_balance);

                let isPrevMismatch = !floatEquals(prevPeriod, openingBalance);
                if (isPrevMismatch) {
                    isPrevMismatch = !item.prev_period.toString().toLowerCase().startsWith("нет");
                }
                if (isPrevMismatch) {
                    this.error_text_1 = "Внимание! Входящий остаток не соответствует Исходящему остатку предыдущего дня"
                }
                const expectedClosing = openingBalance + turnoverDebit - turnoverCredit;
                const isClosingMismatch = !floatEquals(closingBalance, expectedClosing);

                if (isClosingMismatch) {
                    this.error_text_2 = "Импорт невозможен, проверьте правильность расчета Исходящего остатка в файле"
                }
                if (isPrevMismatch || isClosingMismatch) {
                    result++;
                }
            }
        }
        return result;
    }


    get userLogin(): string {
        return this.$store.state.user.login;
    }

    async CheckHash(): Promise<void> {
        if (!this.file || !this.fileName) {
            console.debug("No file selected.", this.file, this.fileName);
            return;
        }

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        try {
            const response = await fetch("/api-py/check-hash", {
                method: "POST",
                body: formData
            });

            const result = await response.json();
            console.log(result);

            if (result === true) {
                this.handleOk();
            } else {
                this.on534ALoad(formData);
            }
        } catch (error) {
            console.error("Error checking hash:", error);
        }
    }

    handleOk(): void {
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        this.$bvModal
            .msgBoxConfirm("Сохранение приведет к изменению ранее принятых данных", {
                title: "Подтвердите",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Сохранить",
                cancelTitle: "Отменить",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then((value: boolean) => {
                console.log("Save", value);
                if (value) {
                    this.on534ALoad(formData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    // on534ALoad(formData: FormData): void {
    //     const user = this.userLogin;
    //     this.$emit("save-load534A", true);

    //     Ax({
    //         url: `/api-py/save-b534A/${user}`,
    //         method: "POST",
    //         data: formData
    //     }, data => {
    //         console.debug("Data", data)
    //     });

    //     this.makeToast("success", "Загрузка файла начата! Результат в журнале Загрузки", "Результат");
    //     this.$emit("save-load534A", false);
    // }

    async on534ALoad(formData: FormData): Promise<any> {
        const user = this.userLogin;

        this.$emit("save-load534A", true);

        this.makeToast(
            "success",
            "Загрузка файла начата! Результат в журнале Загрузки",
            "Результат"
        );

        return new Promise((resolve, reject) => {
            Ax(
                {
                    url: `/api-py/save-b534A/${user}`,
                    method: "POST",
                    data: formData
                },
                (data) => {
                    console.log("SUCCESS", data);
                    this.$emit("save-load534A", false);
                    resolve(data);
                },
                (error) => {
                    console.log("ERROR", error);
                    this.$emit("save-load534A", false);
                    reject(error);
                }
            );
        });
    }

    onClear(): void {
        this.$emit("form-clear534A", []);
        this.error_text_2 = "";
        if (this.propData) {
            this.propData = null
        }
    }

    makeToast(variant: string, tostbody: string, title: string): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }

    keyEvent(event: KeyboardEvent): void {
        // Обработчик событий клавиатуры (пока пуст)
    }
}

